
    import '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/chat-providers/default-chat-provider-width-ui.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/chat-providers/default-chat-provider-width-ui.md?type=demo')
};